import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo3 from "../assets/images-webp/logo3.webp";
import pop from "../assets/images-webp/pop.webp";
import { CMSAPI, EcomAPI } from "../config";
import axios from "axios";
import { FaTimes } from "react-icons/fa";


const Register = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    password: "",
    organization: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    pincode: "",
    landmark: "",
  });

  const [formErrors, setFormErrors] = useState({
    firstName: false,
    lastName: false,
    mobile: false,
    email: false,
    password: false,
    organization: false,
    addressLine1: false,
    city: false,
    state: false,
    pincode: false,
  });

  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [apiError, setApiError] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: false,
      });
    }
    if (apiError) setApiError(null);
  };

  const validateForm = () => {
    const errors = {
      firstName: !formData.firstName.trim(),
      lastName: !formData.lastName.trim(),
      mobile: !/^\d{10}$/.test(formData.mobile),
      email: !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email),
      password: formData.password.length < 6,
      organization: !formData.organization.trim(),
      addressLine1: !formData.addressLine1.trim(),
      city: !formData.city.trim(),
      state: !formData.state.trim(),
      pincode: !formData.pincode.trim(),
    };

    setFormErrors(errors);
    return !Object.values(errors).some((error) => error);
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setApiError(null);
  
  if (!validateForm()) return;

  setIsSubmitting(true);

  try {
    const response = await axios.post(`${CMSAPI}/api/Website/register-customer`, formData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    // Registration successful
    setShowSuccessPopup(true);
    setTimeout(() => {
      setShowSuccessPopup(false);
      navigate("/signin");
    }, 7000);

  } catch (error) {
    console.error("Registration error:", error);
    let errorMessage = "Registration failed";
    
    if (error.response) {
      // The request was made and the server responded with a status code
      if (error.response.data && typeof error.response.data === 'string' && 
          error.response.data.includes("UserId Already Exists")) {
        errorMessage = "This email or phone number is already registered. Please use a different one.";
      } else if (error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
      }
    } else if (error.request) {
      // The request was made but no response was received
      errorMessage = "No response from server. Please try again.";
    }
    
    setApiError(errorMessage);
  } finally {
    setIsSubmitting(false);
  }
};

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      {/* Success Popup */}
      {showSuccessPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-xl shadow-xl text-center max-w-md w-full mx-4">
            <div className="bg-green-100 rounded-full mx-auto w-24 h-24 flex items-center justify-center mb-4">
              <img src={pop} alt="Success" className="w-16 h-16" />
            </div>
            <h4 className="text-xl font-bold mb-2 text-green-600">Congratulations!</h4>
            <p className="text-gray-700 mb-4">
              You've successfully registered with Ajeevi!
            </p>
            <p className="text-md text-gray-600 mb-4">
              Please use your registered email and password to log in.
            </p>
            <button
              onClick={() => {
                setShowSuccessPopup(false);
                navigate("/signin");
              }}
              className="w-full bg-green-600 text-white py-2 rounded-md hover:bg-green-700 transition-colors"
            >
              Continue to Login
            </button>
          </div>
        </div>
      )}

      <div className="w-full max-w-4xl bg-white rounded-lg shadow-md overflow-hidden">
        <FaTimes className="text-gray-500 cursor-pointer text-2xl ml-auto mt-1 mr-1" onClick={()=>navigate("/signin")} />
        <div className="flex flex-col md:flex-row mt-[-10px]">
          {/* Left Section */}
          <div className="hidden md:flex md:w-1/2 bg-white flex-col justify-center items-center p-8 text-center">
            <img
              src={logo3}
              alt="SwachhAJV Logo"
              className="max-w-[150px] mb-4"
            />
            <h5 className="font-bold text-lg">Join AI Enabled Waste Solutions</h5>
            <p className="text-gray-500 text-md mt-2">
              Empowering you with smart tools for waste management.
            </p>
            <Link
              to="/"
              className="mt-4 px-2 py-1 border border-[#00D084] text-[#00D084] rounded-lg text-md hover:bg-[#00D084] hover:text-white transition-colors"
            >
              Go to Home
            </Link>
          </div>

          {/* Right Section */}
          <div className="w-full md:w-1/2 p-6 md:p-8">
            <div className="text-center mb-2">
              <h5 className="font-bold text-[#00D084] mb-1 text-xl">
                Create Account
              </h5>
              <p className="text-gray-500 text-md">
                Fill in the details to get started
              </p>
            </div>

            {/* API Error Message */}
            {apiError && (
              <div className="mb-4 p-3 bg-red-50 border-l-4 border-red-500 text-red-700 rounded">
                <div className="flex items-center">
                  <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                  </svg>
                  <span className="font-medium">Error:</span>
                </div>
                <p className="mt-1 text-sm">{apiError}</p>
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-1">
                {/* First Name */}
                <div>
                  <label htmlFor="firstName" className="block text-md text-gray-600">
                    First Name
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    className={`w-full px-3 py-2 border rounded-md text-sm ${
                      formErrors.firstName ? "border-red-500" : "border-gray-300"
                    }`}
                    required
                  />
                  {formErrors.firstName && (
                    <p className="text-red-500 text-xs mt-1">First name is required.</p>
                  )}
                </div>

                {/* Last Name */}
                <div>
                  <label htmlFor="lastName" className="block text-md text-gray-600">
                    Last Name
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    className={`w-full px-3 py-2 border rounded-md text-sm ${
                      formErrors.lastName ? "border-red-500" : "border-gray-300"
                    }`}
                    required
                  />
                  {formErrors.lastName && (
                    <p className="text-red-500 text-xs mt-1">Last name is required.</p>
                  )}
                </div>

                {/* Phone */}
                <div>
                  <label htmlFor="mobile" className="block text-md text-gray-600">
                    Phone
                  </label>
                  <input
                    type="text"
                    id="mobile"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleInputChange}
                    className={`w-full px-3 py-2 border rounded-md text-sm ${
                      formErrors.mobile ? "border-red-500" : "border-gray-300"
                    }`}
                    required
                  />
                  {formErrors.mobile && (
                    <p className="text-red-500 text-xs mt-1">Enter a valid 10-digit phone number.</p>
                  )}
                </div>

                {/* Email */}
                <div>
                  <label htmlFor="email" className="block text-md text-gray-600">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className={`w-full px-3 py-2 border rounded-md text-sm ${
                      formErrors.email ? "border-red-500" : "border-gray-300"
                    }`}
                    required
                  />
                  {formErrors.email && (
                    <p className="text-red-500 text-xs mt-1">Enter a valid email address.</p>
                  )}
                </div>

                {/* Password */}
                <div>
                  <label htmlFor="password" className="block text-md text-gray-600">
                    Password
                  </label>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    className={`w-full px-3 py-2 border rounded-md text-sm ${
                      formErrors.password ? "border-red-500" : "border-gray-300"
                    }`}
                    required
                    minLength="6"
                  />
                  {formErrors.password && (
                    <p className="text-red-500 text-xs mt-1">Password must be at least 6 characters.</p>
                  )}
                </div>

                {/* Company Name */}
                <div>
                  <label htmlFor="organization" className="block text-md text-gray-600">
                    Company Name
                  </label>
                  <input
                    type="text"
                    id="organization"
                    name="organization"
                    value={formData.organization}
                    onChange={handleInputChange}
                    className={`w-full px-3 py-2 border rounded-md text-sm ${
                      formErrors.organization ? "border-red-500" : "border-gray-300"
                    }`}
                    required
                  />
                  {formErrors.organization && (
                    <p className="text-red-500 text-xs mt-1">Company name is required.</p>
                  )}
                </div>

                {/* Address Line 1 */}
                <div>
                  <label htmlFor="addressLine1" className="block text-md text-gray-600">
                    Address Line 1
                  </label>
                  <input
                    type="text"
                    id="addressLine1"
                    name="addressLine1"
                    value={formData.addressLine1}
                    onChange={handleInputChange}
                    className={`w-full px-3 py-2 border rounded-md text-sm ${
                      formErrors.addressLine1 ? "border-red-500" : "border-gray-300"
                    }`}
                    required
                  />
                  {formErrors.addressLine1 && (
                    <p className="text-red-500 text-xs mt-1">Address line is required.</p>
                  )}
                </div>

                {/* Address Line 2 */}
                <div>
                  <label htmlFor="addressLine2" className="block text-md text-gray-600">
                    Address Line 2
                  </label>
                  <input
                    type="text"
                    id="addressLine2"
                    name="addressLine2"
                    value={formData.addressLine2}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                  />
                </div>

                {/* City */}
                <div>
                  <label htmlFor="city" className="block text-md text-gray-600">
                    City
                  </label>
                  <input
                    type="text"
                    id="city"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    className={`w-full px-3 py-2 border rounded-md text-sm ${
                      formErrors.city ? "border-red-500" : "border-gray-300"
                    }`}
                    required
                  />
                  {formErrors.city && (
                    <p className="text-red-500 text-xs mt-1">City is required.</p>
                  )}
                </div>

                {/* State */}
                <div>
                  <label htmlFor="state" className="block text-md text-gray-600">
                    State
                  </label>
                  <input
                    type="text"
                    id="state"
                    name="state"
                    value={formData.state}
                    onChange={handleInputChange}
                    className={`w-full px-3 py-2 border rounded-md text-sm ${
                      formErrors.state ? "border-red-500" : "border-gray-300"
                    }`}
                    required
                  />
                  {formErrors.state && (
                    <p className="text-red-500 text-xs mt-1">State is required.</p>
                  )}
                </div>

                {/* Pincode */}
                <div>
                  <label htmlFor="pincode" className="block text-md text-gray-600">
                    Pincode
                  </label>
                  <input
                    type="text"
                    id="pincode"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleInputChange}
                    className={`w-full px-3 py-2 border rounded-md text-sm ${
                      formErrors.pincode ? "border-red-500" : "border-gray-300"
                    }`}
                    required
                  />
                  {formErrors.pincode && (
                    <p className="text-red-500 text-xs mt-1">Pincode is required.</p>
                  )}
                </div>

                {/* Landmark */}
                <div>
                  <label htmlFor="landmark" className="block text-md text-gray-600">
                    Landmark
                  </label>
                  <input
                    type="text"
                    id="landmark"
                    name="landmark"
                    value={formData.landmark}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                  />
                </div>
              </div>

              {/* Register Button */}
              <button
                type="submit"
                className="w-full bg-[#00D084] text-white py-2 rounded-md hover:bg-green-600 transition-colors mt-6 disabled:opacity-50"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <span className="flex items-center justify-center">
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Registering...
                  </span>
                ) : "Register"}
              </button>

              {/* Login Link */}
              <div className="text-center mt-4">
                <p className="text-sm">
                  Already have an account?{" "}
                  <Link
                    to="/signin"
                    className="text-[#00D084] font-medium hover:underline"
                  >
                    Login here
                  </Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;